import { Dialog, Transition } from '@headlessui/react'
import React, { Fragment, useContext, useEffect, useRef, useState } from 'react'
import { venueToCardStyle } from '../utils/venue-style-mapping';
import { AppContext, AppFeature } from './AppContext';
import { VenueMarkerIcon } from './VenueMarkerIcon';

export const MultipleVenueModal: React.FC<{ isOpen: boolean, onClose: () => void }> = ({ isOpen, onClose }) => {
    const { venueOptions, setSelectedVenue, setVenueOptions } = useContext(AppContext);
    const [persistedVenueOptions, setPersistedVenueOptions] = useState<AppFeature[]>([]);
    useEffect(() => {
        if(venueOptions && venueOptions.length > 0){
            setPersistedVenueOptions(venueOptions);
        }
    }, [venueOptions, setPersistedVenueOptions]);
    return (
        <>
            <Transition appear show={isOpen} as={Fragment}>
                <Dialog
                    as="div"
                    className="fixed inset-0 z-10 overflow-y-auto bg-opacity-40 transition-all bg-black"
                    onClose={onClose}
                >
                    <div className="min-h-screen px-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0"
                            enterTo="opacity-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Dialog.Overlay className="fixed inset-0" />
                        </Transition.Child>

                        {/* This element is to trick the browser into centering the modal contents. */}
                        <span
                            className="inline-block h-screen align-middle"
                            aria-hidden="true"
                        >
                            &#8203;
                        </span>
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <div className="relative inline-block w-full max-w-sm my-8 overflow-hidden align-middle transition-all transform bg-offwhite shadow paragraph text-center">
                                <button
                                    type="button"
                                    className="inline-block absolute top-2 right-3 text-2xl"
                                    onClick={onClose}
                                >
                                    <i className="fal fa-times"></i>
                                </button>
																<div className="pt-4 md:pt-6 px-4 md:px-6">
																	<Dialog.Title
																			as="h3"
																			className="heading-3"
																	>
																			Multiple venues <br/>at this location
																	</Dialog.Title>
																	<div className="mt-3 paragraph">
																			<p className="mb-4">
																					Select the one you're after
																			</p>
																	</div>
																</div>
                                <div className="mt-5 flex flex-col pb-4 md:pb-6">
                                    {persistedVenueOptions.map((item, i) => <button
                                        key={i}
                                        className={`block py-2 flex flex-row paragraph font-normal text-left hover:bg-stone-300 px-4 md:px-6`}
                                        onClick={() => {
                                            setVenueOptions([]);
                                            setSelectedVenue(item);
                                        }}
                                    >
                                        <div className="pr-2">
                                            <VenueMarkerIcon color={venueToCardStyle(item).backgroundColor} />
                                        </div>
                                        <div className="flex-1">
                                            <div className="font-bold">{item.properties.title}{item.properties && item.properties.room_name && (<span> ({item.properties.room_name})</span>)}</div>
                                            <div className="small-copy">{item.properties.address}</div>
                                        </div>

                                    </button>)}
                                </div>
                            </div>
                        </Transition.Child>
                    </div>
                </Dialog>
            </Transition>
        </>
    )
}